import React, { useState } from 'react';
import { 
  Box, TextField, Button, Typography, Paper, Container, Alert 
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';
import axios from '../../api/axiosConfig';

const Login = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    id: '',
    password: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      // 백엔드 로그인 API 호출 (엔드포인트는 실제 설정에 맞게 수정하세요)
      const response = await axios.post('/api/user/login', credentials);
      
      if (response.status === 200) {
        const { id, name, role, token } = response.data;
        localStorage.setItem('id', id);
        localStorage.setItem('name', name);
        localStorage.setItem('role', role);
        localStorage.setItem('token', token);
        // alert('로그인 성공!');
        navigate('/dashboard'); // 메인으로 이동
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.status === 401) {
          alert("아이디 또는 비밀번호가 올바르지 않습니다.");
      } else {
          alert("로그인 중 서버 오류가 발생했습니다.");
      }
    }
  };

  return (
    <Container maxWidth="xs" sx={{ mt: 10 }}>
      <Paper elevation={6} sx={{ p: 4, borderRadius: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <LoginIcon sx={{ fontSize: 40, color: '#1a233a', mb: 1 }} />
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>로그인</Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            label="아이디"
            name="id"
            margin="normal"
            required
            value={credentials.id}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            label="비밀번호"
            name="password"
            type="password"
            margin="normal"
            required
            value={credentials.password}
            onChange={handleChange}
          />

          <Button
            fullWidth
            variant="contained"
            size="large"
            type="submit"
            sx={{ 
              mt: 3,
              py: 1.5,
              backgroundColor: '#1a233a', 
              '&:hover': { backgroundColor: '#2c3e50' } 
            }}
          >
            로그인
          </Button>
          
          {/* 회원가입 버튼 사용 안함_202602 */}
          {/* --- 회원가입 유도 영역 --- */}
          {/* <Box sx={{ mt: 3, textAlign: 'center', borderTop: '1px solid #eee', pt: 2 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              아직 계정이 없으신가요?
            </Typography>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => navigate('/join')}
              sx={{ 
                color: '#1a233a', 
                borderColor: '#1a233a',
                '&:hover': { borderColor: '#2c3e50', backgroundColor: 'rgba(26, 35, 58, 0.04)' }
              }}
            >
              회원가입 하기
            </Button>
          </Box> */}
        </form>
      </Paper>
    </Container>
  );
};

export default Login;